export function createEvent(event, params) {
    if ( typeof CustomEvent === 'function' ) {
        // If not IE
        return new CustomEvent(event, params);
    }

    return (( customizedEvent, parameters ) => {
        parameters = parameters || { bubbles: false, cancelable: false, detail: undefined };
        const evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( customizedEvent, parameters.bubbles, parameters.cancelable, parameters.detail );
        return evt;
    })(event, params);
}


// WEBPACK FOOTER //
// ./utilities/create-event.js